/**
 * Decorative UI icons for the About Us page.
 *
 * Built on the Home page's existing registry wherever a concept already has an
 * icon there, so the two pages read as one system and nothing new is shipped
 * for its own sake. These are illustrative only — they are not certification
 * marks.
 */
import { FaBalanceScale, FaHandshake, FaShieldAlt } from "react-icons/fa";
import { homeIcons } from "../Home/homeIcons";

export const aboutIcons = {
  // Core values
  integrity: FaBalanceScale,
  excellence: homeIcons.experience,
  partnership: FaHandshake,
  sustainability: homeIcons.sustainability,

  // Expertise
  iso: homeIcons.certificate,
  foodSafety: homeIcons.food,
  infosec: FaShieldAlt,
  textile: homeIcons.textile,
  esg: homeIcons.improvement,
  supplyChain: homeIcons.supplyChain,
  audit: homeIcons.audit,

  // Industry experience
  food: homeIcons.food,
  it: homeIcons.it,
  manufacturing: homeIcons.manufacturing,
  engineering: homeIcons.engineering,
  hospitality: homeIcons.hospitality,
  export: homeIcons.export,
  logistics: homeIcons.supplyChain,

  // Why businesses choose MBA Solutions
  support: homeIcons.support,
  industryFocus: homeIcons.industry,
};

export default aboutIcons;
